import { API_RESULT } from './api';

const UPDATE = 'modules/manageDepartment/UPDATE';

const reducer = (state = 'women', { type, payload }) => {
  switch (type) {
    case UPDATE:
      return payload.department;
    case API_RESULT:
      return payload.department || state;
    default:
      return state;
  }
};

const updateDepartment = department => ({
  payload: { department },
  type: UPDATE,
});

export { reducer as default, updateDepartment };
